<div class="expand-collapse-panel">
  <form autocomplete="off" class="filter-form">
    @for (field of fields; track field.key) {
      <div class="filter-field">
        <mat-form-field class="search-input">
          <mat-label>{{field.label}}</mat-label>
          <input matInput type="text"
            [placeholder]="field.placeholder || field.label"
            [ngModel]="field.value"
            (ngModelChange)="onFieldChange(field, $event)"
            [ngModelOptions]="{standalone: true}" />
        </mat-form-field>
      </div>
    }
    <div class="filter-actions text-filter-bar-actions">
      <button type="button" class="btn mat-flat-button btn-primary" (click)="clearFilters()">
        Clear
      </button>
    </div>
  </form>
</div>
